export default __webpack_public_path__ + "static/media/news_thumbnail.5a915d11.jpg";